<template>
  <div class="activity-title" >
    <img :src="list[index]" alt="">
  </div>
</template>
<script>
export default {
  name: 'activityTitle',
  props: {
    index: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      list: [
        'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660702447539.png',//网络营销
        'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659700767235.png',// 人工智能
        'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660702333225.png',//家政
        'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660702371359.png',// 应急安全
        'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659700821956.png',//退役军人
        'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660702389237.png' // 交通
      ]
    }
  }
}
</script>
<style lang="stylus" scoped>
  .activity-title {
    margin-top: 26px;
    font-size:0;
    img {
      width: 214px;
      height: 66px;
      display:block
    }
  }
</style>